export default __webpack_public_path__ + "static/media/permission_web.446b3560.png";